const Loading = () => {
  return (
    <div className="fixed top-0 left-0 z-50 flex h-screen w-screen items-center justify-center justify-items-center bg-blue-500/50">
      <p className="text-2xl font-bold text-white">loading...</p>
    </div>
  );
};

export default Loading;
